import { render, staticRenderFns } from "./Vehiculo.vue?vue&type=template&id=b55a5e68&scoped=true&"
import script from "./Vehiculo.vue?vue&type=script&lang=js&"
export * from "./Vehiculo.vue?vue&type=script&lang=js&"
import style0 from "./Vehiculo.vue?vue&type=style&index=0&id=b55a5e68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55a5e68",
  null
  
)

export default component.exports